var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusPaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.816 11.187a.87.87 0 00-1.093.564v.005l-.735 2.376a1 1 0 01-1.91-.59l.733-2.374c.464-1.523 2.074-2.349 3.582-1.897l.003.001c1.524.463 2.35 2.075 1.898 3.583l-.002.008-.734 2.376a1 1 0 11-1.91-.59l.732-2.372a.87.87 0 00-.564-1.09z",
    fill: "url(#statusPaid_svg__paint0_linear_2628_1738)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.525 12.455a.87.87 0 00-1.093.565l-.002.006-1.107 3.57a1 1 0 11-1.91-.593l1.106-3.567c.465-1.523 2.075-2.348 3.582-1.896l.003.001c1.525.463 2.351 2.075 1.899 3.583l-.002.008-2.202 7.127a1 1 0 11-1.911-.59l2.2-7.123a.87.87 0 00-.563-1.09z",
    fill: "url(#statusPaid_svg__paint1_linear_2628_1738)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.848 14.918a.87.87 0 00-1.093.565l-.001.004-1.17 3.794a1 1 0 11-1.91-.59l1.168-3.791c.464-1.524 2.075-2.35 3.582-1.897l.003.001c1.525.463 2.351 2.075 1.899 3.583l-.003.009-1.654 5.348a1 1 0 11-1.91-.591l1.652-5.344a.87.87 0 00-.564-1.09z",
    fill: "url(#statusPaid_svg__paint2_linear_2628_1738)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.652 14.67a.87.87 0 00-1.092.564l-.002.005-2.202 7.127a1 1 0 11-1.91-.59l2.2-7.123.001-.005c.465-1.522 2.075-2.346 3.582-1.894l.003.001c1.525.463 2.351 2.075 1.899 3.583l-.003.008-2.87 9.293 2.003-1.266c.046-.03.096-.055.147-.077a2.498 2.498 0 012.926.752c.829 1.05.68 2.585-.35 3.441l-.138.149-.52.553c-.443.468-1.065 1.12-1.782 1.852-1.43 1.46-3.263 3.265-4.823 4.59a7.202 7.202 0 01-6.816 1.4l-3.01-.933a1 1 0 11.592-1.91l3.01.933a5.204 5.204 0 004.926-1.012l.003-.002c1.487-1.263 3.267-3.014 4.689-4.466a143.605 143.605 0 002.268-2.37l.136-.146.035-.037.01-.012s.081-.08.126-.115a.485.485 0 00.074-.678.5.5 0 00-.524-.165l-4.203 2.655a1 1 0 01-1.49-1.14l3.669-11.875a.87.87 0 00-.564-1.09z",
    fill: "url(#statusPaid_svg__paint3_linear_2628_1738)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.612 14.159a.866.866 0 00-1.124-.49.883.883 0 00-.5 1.133l.92 2.31a1 1 0 01-1.86.739l-.922-2.32a2.883 2.883 0 011.615-3.717 2.866 2.866 0 013.727 1.6l.002.003.92 2.314a1 1 0 01-1.858.74l-.92-2.312z",
    fill: "url(#statusPaid_svg__paint4_linear_2628_1738)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.99 15.092a.866.866 0 00-1.123-.49.877.877 0 00-.488 1.133l2.76 6.937a1 1 0 01-1.858.74l-2.764-6.948a2.877 2.877 0 011.603-3.717 2.866 2.866 0 013.727 1.6l.001.003 1.381 3.47a1 1 0 01-1.858.74l-1.38-3.468z",
    fill: "url(#statusPaid_svg__paint5_linear_2628_1738)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.842 17.181a.866.866 0 00-1.124-.489.866.866 0 00-.49 1.125l.001.004 2.065 5.2a1 1 0 01-1.859.738l-2.063-5.195-.001-.004c-.595-1.48.14-3.135 1.6-3.723a2.866 2.866 0 013.727 1.599l.002.004 4.59 11.556a7.22 7.22 0 01-4.042 9.372l-3.858 1.53a7.244 7.244 0 01-6.899-.864l-.004-.003c-1.654-1.203-3.622-2.86-5.163-4.202a150.674 150.674 0 01-2.484-2.215l-.152-.138-.003-.003a2.485 2.485 0 01-.613-3.403 2.482 2.482 0 012.88-.97c.046.015.09.035.133.057l2.094 1.102-3.603-9.046a2.864 2.864 0 011.62-3.706 2.848 2.848 0 013.713 1.608l2.748 6.94a1 1 0 01-1.86.736l-2.75-6.947a.848.848 0 00-1.109-.48l-.01.004a.864.864 0 00-.49 1.116l4.601 11.551a1 1 0 01-1.395 1.256l-4.407-2.32a.487.487 0 00-.502.21l-.003.004a.486.486 0 00.14.677c.042.029.082.06.12.095l.05.046.147.134a149.554 149.554 0 002.45 2.184c1.53 1.335 3.443 2.943 5.022 4.09a5.243 5.243 0 004.992.628l3.854-1.53a5.22 5.22 0 002.924-6.775l-4.59-11.553c.001 0 0 0 0 0z",
    fill: "url(#statusPaid_svg__paint6_linear_2628_1738)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.96 28.798c-.715-.408-1.664-.553-2.432-.392-.416.087-.658.244-.825.415-.18.185-.327.442-.461.806a1 1 0 01-1.876-.694c.185-.5.453-1.044.904-1.508.465-.477 1.073-.815 1.848-.977 1.25-.262 2.698-.035 3.834.614a1 1 0 01-.992 1.736z",
    fill: "url(#statusPaid_svg__paint7_linear_2628_1738)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.834 4.79a1 1 0 011 1v2.488a1 1 0 11-2 0V5.789a1 1 0 011-1z",
    fill: "url(#statusPaid_svg__paint8_linear_2628_1738)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.76 7.568a1 1 0 010 1.415l-1.867 1.865a1 1 0 01-1.414-1.414l1.866-1.866a1 1 0 011.414 0z",
    fill: "url(#statusPaid_svg__paint9_linear_2628_1738)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.906 7.568a1 1 0 011.415 0l1.865 1.866a1 1 0 11-1.414 1.415l-1.866-1.866a1 1 0 010-1.415z",
    fill: "url(#statusPaid_svg__paint10_linear_2628_1738)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.368 40.3a1 1 0 011 1v2.49a1 1 0 01-2 0V41.3a1 1 0 011-1z",
    fill: "url(#statusPaid_svg__paint11_linear_2628_1738)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.013 38.727a1 1 0 011.414 0l1.866 1.866a1 1 0 01-1.414 1.415l-1.866-1.866a1 1 0 010-1.415z",
    fill: "url(#statusPaid_svg__paint12_linear_2628_1738)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.72 38.727a1 1 0 010 1.415l-1.866 1.866a1 1 0 01-1.414-1.415l1.866-1.866a1 1 0 011.414 0z",
    fill: "url(#statusPaid_svg__paint13_linear_2628_1738)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint0_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint1_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint2_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint3_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint4_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint5_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint6_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint7_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint8_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint9_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint10_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint11_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint12_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "statusPaid_svg__paint13_linear_2628_1738",
    x1: 24.259,
    y1: 4.789,
    x2: 24.259,
    y2: 44.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })))));
}
export default __webpack_public_path__ + "static/statusPaid.272f984d.svg";
export { SvgStatusPaid as ReactComponent };